import { Element } from "domhandler"
import DOMPurify from "dompurify"
import React, { useMemo } from "react"
import parse, { HTMLReactParserOptions, domToReact } from "html-react-parser"
import { makeStyles } from "tss-react/mui"
import { ExternalLink } from "../links/ExternalLink"
import type { DOMNode } from "html-dom-parser"

const useStyles = makeStyles()(() => ({
    wrapper: {
        "& * > img": {
            width: "100%",
            height: "auto",
        },
    },
}))

const parserOptions: HTMLReactParserOptions = {
    replace: (node: DOMNode) => {
        if (node instanceof Element && node.name === "a") {
            return (
                <ExternalLink href={node.attribs["href"]} color="primary">
                    {domToReact(node.children as DOMNode[], parserOptions)}
                </ExternalLink>
            )
        }

        return
    },
}

type DynamicHtmlProps = Readonly<{
    html: string
    className?: string
}>

export function DynamicHtml({ html, className }: DynamicHtmlProps) {
    const { classes, cx } = useStyles()

    // Even though API should always sanitize HTML from user input, we perform a client-side sanitization for defense-in-depth
    // NOTE: We disallow MathML and SVG content since they should not be needed when content comes from our rich text editor
    const sanitized = useMemo(
        () => DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, ALLOW_UNKNOWN_PROTOCOLS: false }),
        [html, DOMPurify.sanitize],
    )
    const components = useMemo(() => parse(sanitized, parserOptions), [sanitized, parse])

    return <div className={cx(className, classes.wrapper)}>{components}</div>
}
